import { render, staticRenderFns } from "./btn.vue?vue&type=template&id=3fafcdcb"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"
import style0 from "./btn.vue?vue&type=style&index=0&id=3fafcdcb&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fafcdcb')) {
      api.createRecord('3fafcdcb', component.options)
    } else {
      api.reload('3fafcdcb', component.options)
    }
    module.hot.accept("./btn.vue?vue&type=template&id=3fafcdcb", function () {
      api.rerender('3fafcdcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uploader/btn.vue"
export default component.exports